var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar',{ref:"bar",attrs:{"title":"true","close":"true","titleText":"Supera el reto"}}),_c('play-verse',{ref:"playVerse"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }